module.exports = __webpack_public_path__ + "static/media/train1.6a84a5ec.png";